import React, { createContext } from 'react';
import PropTypes from 'prop-types';

export const CartItemEventContext = createContext();

const CartItemEventProvider = ({ children, eventDataForMember, eventRegistrationData }) => {
    return (
        <CartItemEventContext.Provider value={{ eventDataForMember, eventRegistrationData }}>
            {children}
        </CartItemEventContext.Provider>
    );
};

CartItemEventProvider.propTypes = {
    children: PropTypes.node.isRequired,
    eventDataForMember: PropTypes.object.isRequired,
    eventRegistrationData: PropTypes.object.isRequired,
};

export default CartItemEventProvider;
